import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M764.385882,112.941176 L990.268235,451.764706 L1920,451.764706 L1920,1637.64706 C1920,1725.86039 1852.20148,1798.55965 1765.9842,1806.36508 L1750.58824,1807.05882 L169.411765,1807.05882 C81.1984314,1807.05882 8.49917211,1739.26031 0.693740014,1653.04302 L0,1637.64706 L0,112.941176 L764.385882,112.941176 Z M703.849412,225.882353 L112.941176,225.882353 L112.941176,1637.64706 C112.941176,1665.35529 133.019608,1688.42318 159.295086,1693.2073 L169.411765,1694.11765 L1750.58824,1694.11765 C1778.19608,1694.11765 1801.34205,1674.12845 1806.14476,1647.79348 L1807.05882,1637.64706 L1807.05882,564.705882 L225.882353,564.705882 L225.882353,451.764706 L854.4,451.764706 L703.849412,225.882353 Z M1016.47059,790.588235 L1016.47059,1072.94118 L1298.82353,1072.94118 L1298.82353,1185.88235 L1016.47059,1185.88235 L1016.47059,1468.23529 L903.529412,1468.23529 L903.529412,1185.88235 L621.176471,1185.88235 L621.176471,1072.94118 L903.529412,1072.94118 L903.529412,790.588235 L1016.47059,790.588235 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconAddFolderLine = /*#__PURE__*/function (_Component) {
  _inherits(IconAddFolderLine, _Component);

  var _super = _createSuper(IconAddFolderLine);

  function IconAddFolderLine() {
    _classCallCheck(this, IconAddFolderLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconAddFolderLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconAddFolder",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconAddFolderLine.displayName = "IconAddFolderLine";
  return IconAddFolderLine;
}(Component);

IconAddFolderLine.glyphName = 'add-folder';
IconAddFolderLine.variant = 'Line';
IconAddFolderLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconAddFolderLine;
export { IconAddFolderLine };